// Debug helper for TikTok Pixel troubleshooting
// Run this in the browser console to diagnose pixel issues

export function debugTikTokPixel() {
  console.log('=== TikTok Pixel Debug Info ===');
  
  // Check environment variables
  console.log('\n1. Environment Variables:');
  console.log('   REACT_APP_ENABLE_TIKTOK_PIXEL:', process.env.REACT_APP_ENABLE_TIKTOK_PIXEL);
  console.log('   REACT_APP_TIKTOK_PIXEL_ID:', process.env.REACT_APP_TIKTOK_PIXEL_ID);
  
  // Check consent
  console.log('\n2. User Consent:');
  const consent = localStorage.getItem('marketing_consent');
  console.log('   marketing_consent:', consent);
  console.log('   Has consent:', consent === 'true');
  
  // Check if pixel loaded
  console.log('\n3. Pixel Status:');
  console.log('   window.ttq exists:', typeof window.ttq !== 'undefined');
  console.log('   window.ttq:', window.ttq);
  
  // Check network requests
  console.log('\n4. To check network requests:');
  console.log('   - Open DevTools → Network tab');
  console.log('   - Filter by "tiktok"');
  console.log('   - Look for: analytics.tiktok.com/i18n/pixel/events.js');
  
  // Diagnosis
  console.log('\n5. Diagnosis:');
  const pixelEnabled = process.env.REACT_APP_ENABLE_TIKTOK_PIXEL === 'true';
  const hasPixelId = !!process.env.REACT_APP_TIKTOK_PIXEL_ID;
  const hasConsent = consent === 'true';
  const pixelLoaded = typeof window.ttq !== 'undefined';
  
  if (!pixelEnabled) {
    console.warn('   ❌ REACT_APP_ENABLE_TIKTOK_PIXEL is not set to "true"');
    console.log('   → Add environment variable in Vercel: REACT_APP_ENABLE_TIKTOK_PIXEL=true');
  }
  
  if (!hasPixelId) {
    console.warn('   ❌ REACT_APP_TIKTOK_PIXEL_ID is not set');
    console.log('   → Add environment variable in Vercel: REACT_APP_TIKTOK_PIXEL_ID=D4AAOGRC77U1PLJOHCN0');
  }
  
  if (!hasConsent) {
    console.warn('   ❌ User has not granted marketing consent');
    console.log('   → Accept cookies via the banner');
    console.log('   → Or run: localStorage.setItem("marketing_consent", "true"); location.reload()');
  }
  
  if (pixelEnabled && hasPixelId && hasConsent && !pixelLoaded) {
    console.warn('   ❌ Pixel should load but window.ttq is not found');
    console.log('   → Check Network tab for blocked requests');
    console.log('   → Disable ad blockers');
    console.log('   → Check browser console for errors');
  }
  
  if (pixelLoaded) {
    console.log('   ✅ TikTok Pixel is loaded and ready!');
    console.log('   → Test with: window.ttq.track("TestEvent", {test: true})');
  }
  
  console.log('\n=== End Debug Info ===\n');
  
  return {
    pixelEnabled,
    hasPixelId,
    hasConsent,
    pixelLoaded,
    allGood: pixelEnabled && hasPixelId && hasConsent && pixelLoaded
  };
}

// Make it available globally for console debugging
if (typeof window !== 'undefined') {
  window.debugTikTokPixel = debugTikTokPixel;
}

